"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavigationMenuSection = exports.StyledNavigationMenuGroup = exports.StyledNavigationMenu = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const CSSMinWidth = (0, styled_components_1.css) `
    min-width: 115px;
`;
exports.StyledNavigationMenu = styled_components_1.default.div `
    display: inline-flex;
    flex-shrink: 0;
    flex-direction: column;
    height: 100%;
    background-color: ${({ theme }) => theme.colorNavBackground};
    width: ${({ width }) => width};
    ${({ hideBorder }) => hideBorder
    ? (0, styled_components_1.css) `
                  overflow-y: auto;
                  overflow-x: hidden;
              `
    : (0, styled_components_1.css) `
                  border-right: ${helpers_1.BASE_BORDER_WIDTH} solid
                      ${({ theme }) => theme.colorNavSideSeparator};
              `}
    ${CSSMinWidth}
`;
exports.StyledNavigationMenuGroup = styled_components_1.default.div `
    ${CSSMinWidth}
`;
exports.StyledNavigationMenuSection = styled_components_1.default.div `
    box-sizing: border-box;
    flex-grow: 1;
    padding-top: ${helpers_1.SPACING_M};
`;
//# sourceMappingURL=NavigationMenu.styles.js.map